import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { enqueueSnackbar, useSnackbar } from "notistack";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useIds } from "../../hook/AdminContext";
import LoginSlide from "./components/loginSlide";
import Registration from "./components/Registration";
import { login } from "../../DAL/auth/auth";

export default function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const registerParam = searchParams.get("register");
  const { enqueueSnackbar } = useSnackbar();
  const [showLoader, setShowLoader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [registerPopupOpen, setRegisterPopupOpen] = useState(
    registerParam || false
  );
  const [userType, setUserType] = useState("client");

  const { setUserInfo, adminSetting, fetctUserDetail, setUserToken } = useIds();
  const navigate = useNavigate();
  const [loginStates, setLoginStates] = useState({
    email: "",
    password: "",
    loading: false,
  });

  const handleChange = (e) => {
    setLoginStates({ ...loginStates, [e.target.name]: e.target.value });
  };

  const navigateForgot = (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/forgot-password");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginStates((old) => ({ ...old, loading: true }));
    const login_data = {
      email: loginStates.email,
      password: loginStates.password,
      type: 1,
    };
    const response = await login(login_data);
    if (response.code === 200) {
      localStorage.setItem("token", response.token);
      setUserToken(response.token);
      localStorage.setItem("user", JSON.stringify(response.user));
      setUserInfo(response.user);
      fetctUserDetail();
      setLoginStates((old) => ({ ...old, loading: false }));
      setShowLoader(true);
      setTimeout(() => {
        let redirectUrl = sessionStorage.getItem("redirect-url");
        if (redirectUrl) {
          sessionStorage.removeItem("redirect-url");
          navigate(redirectUrl);
        } else {
          navigate("/home");
        }
        enqueueSnackbar(response.message, { variant: "success" });
      }, 3000);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoginStates((old) => ({ ...old, loading: false }));
    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    setRegisterPopupOpen(true);
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const handleRegisterClose = () => {
    setRegisterPopupOpen(false);
  };
  const handleRegisterConfirm = () => {
    setRegisterPopupOpen(false);

    if (userType === "candidate") {
      const candidateUrl = adminSetting?.candidate_redirect_url;
      if (candidateUrl && candidateUrl.trim() !== "") {
        window.open(candidateUrl, "_blank");
      } else {
        window.open(
          "https://clientdev.talentsourceplatform.com/login",
          "_blank"
        );
      }
    } else {
      const clientUrl = adminSetting?.client_redirect_url;
      if (clientUrl && clientUrl.trim() !== "") {
        window.open(`${clientUrl}`, "_blank");
      } else {
        console.warn("client_redirect_url is not defined or empty.");
      }
    }
  };

  useEffect(() => {
    if (showLoader) {
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            navigate("/home");
            return 100;
          }
          return prev + 2; // increase 2% every 100ms (approx 5 seconds)
        });
      }, 100);
      return () => clearInterval(interval);
    }
  }, [showLoader]);

  useEffect(() => {
    const invalid = searchParams.get("invalid_token");

    if (invalid === "true") {
      enqueueSnackbar("Your session has expired. Please log in again.", {
        variant: "error",
      });

      // Remove query params from the URL after showing the message
      navigate("/login", { replace: true });
    }
  }, [searchParams, enqueueSnackbar, navigate]);
  if (showLoader) {
    return <LoginSlide progress={progress} />;
  }

  return (
    <div className="container login-page">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-xl-4 login-box mt-5">
          <h2 className="login-title">Login</h2>
          <p className="login-subtitle">
            Login allows user access by verifying credentials like username and
            password.
          </p>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="mb-3 email-field">
              <label htmlFor="" className="mb-1 form-label">
                Email*
              </label>
              <input
                required
                style={{ borderRadius: "5px" }}
                type="email"
                name="email"
                value={loginStates.email}
                onChange={handleChange}
                placeholder="Enter your email*"
                className="input-field email-input"
              />
            </div>
            <div className="position-relative password-field">
              <label htmlFor="" className="mb-1 form-label">
                Password*
              </label>
              <input
                required
                type={passwordVisible ? "text" : "password"}
                name="password"
                value={loginStates.password}
                onChange={handleChange}
                placeholder="Enter Password*"
                className="input-field password-input"
              />
              <span
                className="eye-icon position-absolute"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ right: "18px", top: "35px", cursor: "pointer" }}
              >
                {passwordVisible ? (
                  <VisibilityOutlinedIcon className="eye-icon" />
                ) : (
                  <VisibilityOffOutlinedIcon className="eye-icon" />
                )}
              </span>
            </div>
            <div className="d-flex justify-content-end login-forgot-password">
              <span
                onClick={navigateForgot}
                className="text-white text-end cursor-pointer mt-1"
              >
                Forgot Password?
              </span>
            </div>
            <button
              type="submit"
              className="large-button-contained mt-3"
              disabled={loginStates.loading}
            >
              {loginStates.loading ? "Logging in..." : "Login"}
            </button>
          </form>
          <p className="text-center mt-2 color-white" style={{ marginTop: 0 }}>
            Don't have an account?{" "}
            <a
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                letterSpacing: "1px",
                color: "#fff",
              }}
              onClick={handleRegisterClick}
            >
              Register
            </a>
          </p>
        </div>
      </div>

      {/* Registration Type Popup */}
      <Registration
        handleRegisterConfirm={handleRegisterConfirm}
        registerPopupOpen={registerPopupOpen}
        handleRegisterClose={handleRegisterClose}
        handleUserTypeChange={handleUserTypeChange}
        userType={userType}
      />
    </div>
  );
}
